import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'panel',
    loadChildren: () => import(`./pages/privates/private.module`).then(m => m.PrivateModule),
  },
  {
    path: '',
    loadChildren: () => import(`./pages/publics/public.module`).then(m => m.PublicModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
